import React from "react"
import { Loader, Button } from "@bw/bits"
import * as yup from "yup"
import { Formik, Form as FormWrap } from "formik"
import { toast } from "react-toastify"
import {
  displayField,
  postFormFields,
  getFormFields,
  getInitialValues,
  fieldsSchema,
} from "./form-actions"
import { useTranslation } from "react-i18next"
import styled from "styled-components"

const PROTECTED_FORMS = ["test_nouveau"]

const Form = ({ handle, initialValues }) => {
  const [formIsSent, setFormIsSent] = React.useState(false)
  const [formAlreadySent, setFormAlreadySent] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(true)
  const [fields, setFields] = React.useState(null)
  const [isSuccess, setIsSuccess] = React.useState(false)
  const { t } = useTranslation()

  React.useEffect(() => {
    getFormFields(handle)
      .then(data => {
        setFields(data)
        setIsSuccess(true)
      })
      .catch(() => {
        setIsSuccess(false)
      })
      .finally(() => {
        setIsLoading(false)
      })

    if (PROTECTED_FORMS.includes(handle)) {
      const lastSubmit = localStorage.getItem(handle + "_submitted")

      if (Date.now() - lastSubmit < 3600 * 24 * 1000) {
        setFormAlreadySent(true)
      }
    }
  }, [handle])

  if (!isSuccess) {
    return null
  }
  if (formAlreadySent) {
    return <div>Vous avez déjà envoyé ce formulaire il y a peu de temps.</div>
  }

  return (
    <>
      {isLoading && (
        <Loader
          messages={[t("loading"), t("loadingTakesLonger")]}
          treshold={5}
        />
      )}

      {isSuccess && formIsSent === false && (
        <Formik
          initialValues={{ ...getInitialValues(fields), ...initialValues }}
          validationSchema={yup.object().shape({
            ...fieldsSchema(fields, t),
          })}
          onSubmit={async values => {
            localStorage.setItem(handle + "_submitted", Date.now())

            return postFormFields(handle, values)
              .then(() => {
                setFormIsSent(true)
                localStorage.setItem(handle + "_submitted", Date.now())
              })
              .catch(() => {
                toast.error(t("form.sentFail"))
              })
          }}
        >
          {formik => (
            <FormWrap>
              <FieldList>
                {Object.values(fields).map(field => (
                  <FieldWidth key={field.handle} percent={field.width}>
                    {displayField(field, formik)}
                  </FieldWidth>
                ))}
              </FieldList>
              <p>
                <Button
                  submit
                  label={t("form.buttonSubmit")}
                  disabled={formik.isSubmitting}
                />
              </p>
            </FormWrap>
          )}
        </Formik>
      )}
      {formIsSent && <div>{t("form.sentSuccess")}</div>}
    </>
  )
}

const FieldWidth = styled.div`
  @media (min-width: 768px) {
    flex: 0 0 calc(${props => props.percent || 100}% - 20px);
  }
`

const FieldList = styled.div`
  @media (min-width: 768px) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    column-gap: 20px;
  }
`

export { Form }
